import { TableColumn } from "../../types/table-column";

export const AIProductsColumns: TableColumn[] = [
  {
    type: "string",
    fieldName: "TITLE",
    value: "title",
    secondaryValue: "internalId",
    width: 50,
  },

  {
    type: "arrayIcons",
    fieldName: "APPLICATION_AREAS",
    value: "areas",
    width: 16,
  },
  // {
  //   type: "arrayIcons",
  //   fieldName: "ALGORITHM",
  //   value: "algorithms",
  //   width: 13,
  // },
  {
    type: "object",
    fieldName: "RISK",
    value: "riskLevel",
    width: 13,
  },
  // {
  //   type: "questions_status",
  //   fieldName: "PROGRESS",
  //   value: "answeredQuestions",
  //   width: 10,
  // },
  // {
  //   type: "task",
  //   fieldName: "TASKS",
  //   value: "completedTasks",
  //   width: 5,
  // },
  {
    type: "string",
    fieldName: "RESPONSIBLE",
    value: "keyContact",
    width: 12,
  },
  {
    type: "release",
    fieldName: "RELEASE",
    value: "release",
    width: 5,
  },
  {
    type: "date",
    fieldName: "LAST_MODIFIED",
    value: "updatedAt",
    width: "fit-content",
  },
];
